import './styles/tokens.css';
import './styles/global.css';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import HabitItPrivacy from './pages/HabitItPrivacy';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/habit-it/privacy" element={<HabitItPrivacy />} />
    </Routes>
  );
}

export default App;
